var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevron = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.75 21c-.32 0-.64-.126-.884-.377l-7.5-7.714a1.31 1.31 0 0 1 0-1.818l7.5-7.714a1.225 1.225 0 0 1 1.767 0 1.31 1.31 0 0 1 0 1.818L10.017 12l6.617 6.806a1.31 1.31 0 0 1 0 1.818 1.23 1.23 0 0 1-.885.376"
})));
export default SvgChevron;